var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAyuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.368 26.302H12.6319C12.1111 26.302 11.5903 25.7785 11.5903 25.255C11.5903 24.7315 12.1111 24.208 12.6319 24.208H14.368C14.8889 24.208 15.4097 24.7315 15.4097 25.255C15.4097 25.953 14.8889 26.302 14.368 26.302Z",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29862 13.3891C4.29862 13.3891 1.69446 13.5636 1.69446 15.4831V16.7046C1.69446 18.624 3.25696 19.1475 3.9514 19.1475C4.12501 19.1475 4.29862 18.973 4.29862 18.7985V18.624V14.6106V10.9462C4.29862 9.55019 4.47224 7.97972 5.34029 6.40925C6.20835 4.83878 7.59724 3.09381 10.0278 2.22133C12.2847 1.52334 14.8889 1.17435 17.1458 2.22133C19.0556 3.09381 20.4445 4.31529 21.1389 5.71126C22.3542 7.45623 22.875 9.55019 22.875 11.8186V13.5636V18.4495C22.875 18.7985 22.7014 18.973 22.5278 19.322L17.8403 24.9059C17.6667 25.2549 17.3195 25.2549 16.9722 25.2549H15.4097",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.875 13.3892C22.875 13.3892 25.3056 14.0871 25.3056 15.1341C25.3056 15.6576 25.3056 16.5301 25.3056 17.4026C25.3056 17.5771 24.7847 19.322 22.875 18.9731",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyuda);
export default __webpack_public_path__ + "static/media/ayuda.c2be4fc0b9adc9203bf6c63c507e1672.svg";
export { ForwardRef as ReactComponent };